import axios from 'axios';
import { getToken } from './auth';

const API_URL = 'https://backend.chamafruits.com';

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  const token = getToken();

  const response = await axios.post(`${API_URL}/aws`, formData, {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};